function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.71008 1.36363C6.98284 1.67536 6.95126 2.14918 6.63953 2.42194L1.49388 6.92439C1.18215 7.19715 0.708329 7.16557 0.435568 6.85384C0.162806 6.54211 0.194394 6.06829 0.506121 5.79553L5.65177 1.29308C5.9635 1.02032 6.43732 1.0519 6.71008 1.36363Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.10718 1C1.10718 0.585786 1.44297 0.25 1.85718 0.25H7.75283V6.14565C7.75283 6.55986 7.41704 6.89565 7.00283 6.89565C6.58862 6.89565 6.25283 6.55986 6.25283 6.14565V1.75H1.85718C1.44297 1.75 1.10718 1.41421 1.10718 1Z"
});

var SvgExternalLink = function SvgExternalLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "#447AFB",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExternalLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/external-link.fe443ecb.svg";
export { ForwardRef as ReactComponent };